import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import ServiceBanner from "../Components/ServiceBanner";
import Footer from "../Components/Footer";
import ServiceBar from "../Components/ServiceBar";
import customBanner from "../Images/auto.jpg";

export default function About() {
  return (
    <>
      <div className="fadeIn animated">
        <ServiceBanner
          customImage={customBanner}
        />

        <Row className="no-gutters mt-4 ">
          <Container>
            <Row>
              <Col sm={12} className="text-center ">
              <h3>WATER QUALITY MANAGEMENT</h3>
                <blockquote className="mt-4 font-italic">
                  <sup>
                    <i className="fa fa-quote-left" aria-hidden="true"></i>
                  </sup>{" "}
                 We develop smart water quality monitoring systems using IoT sensors and data analytics to continuously measure parameters such as pH, turbidity, conductivity, and chemical composition. Designed for municipalities, industries, and environmental agencies, our solutions ensure clean water usage, enable early detection of contamination, and support sustainable water management.{" "}
                  <sup>
                    <i className="fa fa-quote-right" aria-hidden="true"></i>
                  </sup>
                </blockquote>
              </Col>
            </Row>
          </Container>
        </Row>

       <section className="py-5 bg-light">
  <Container>
    <Row className="text-center">
      {/* Feature 1 */}
      <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp">
        <i className="bi bi-clock-history fa-3x mb-3 text-info"></i>
        <hr className="my-3" />
        <h5>Real-Time Parameter Tracking</h5>
        <div className="btSubTitle small">
          Continuous measurement of pH, turbidity, dissolved oxygen, and TDS levels.
        </div>
       
      </Col>

      {/* Feature 2 */}
      <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-1s">
        <i className="bi bi-layers fa-3x mb-3 text-success"></i>
        <hr className="my-3" />
        <h5>IoT-Enabled Remote Monitoring</h5>
        <div className="btSubTitle small">
          Cloud-based dashboards and mobile alerts for anytime, anywhere access.
        </div>
      
      </Col>

      {/* Feature 3 */}
      <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-2s">
        <i className="bi bi-app-indicator fa-3x mb-3 text-danger"></i>
        <hr className="my-3" />
        <h5>Automatic Alerts & Notifications</h5>
        <div className="btSubTitle small">
         Instant alerts on threshold breaches for proactive response and issue resolution.
        </div>
        
      </Col>
    </Row>
    <br />
    <Row className="text-center">
      {/* Feature 1 */}
      <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp">
        <i class="bi bi-pie-chart fa-3x mb-3 text-warning"></i>
        <hr className="my-3" />
        <h5>Regulatory Compliance Reports</h5>
        <div className="btSubTitle small">
          Auto-generated data logs and reports to meet environmental standards.
        </div>
      
      </Col>

      {/* Feature 2 */}
      <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-1s">
        <i className="bi bi-motherboard fa-3x mb-3 text-primary"></i>
        <hr className="my-3" />
        <h5>Customizable Sensor Integration</h5>
        <div className="btSubTitle small">
        Compatible with diverse water bodies and industrial pipelines.
        </div>
       
      </Col>

      {/* Feature 3 */}
      <Col md={4} sm={6} xs={12} className="mb-4 animate__animated animate__fadeInUp animate__delay-2s">
        <i className="bi bi-battery fa-3x mb-3 text-secondary"></i>
       
        <hr className="my-3" />
        <h5>Battery or Solar-Powered Options</h5>
        <div className="btSubTitle small">
         Flexible deployment in both remote and urban locations.
        </div>
      
      </Col>
    </Row>
  </Container>
</section>


        <ServiceBar />
        <Footer />
      </div>
    </>
  );
}
